import { useState } from "react";
import type { AnonymousResultsTreeProps } from "../../type/result";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import TestResultListItem from "../testResultListItem/testResultListItem";
import "./anonymousResultsTree.scss";

export default function AnonymousResultsTree({
  groups,
  selectedItem,
  onSelect,
  formatDate,
}: AnonymousResultsTreeProps) {
  const { t } = useI18n();
  const [expandedIps, setExpandedIps] = useState<Set<string>>(
    () => new Set(groups.map((g) => g.ip_address))
  );

  function toggleIp(ip: string) {
    setExpandedIps((prev) => {
      const next = new Set(prev);
      if (next.has(ip)) {
        next.delete(ip);
      } else {
        next.add(ip);
      }
      return next;
    });
  }

  if (groups.length === 0) {
    return (
      <div className="anon-tree__empty">
        {t("Brak wyników anonimowych.")}
      </div>
    );
  }

  return (
    <ul className="anon-tree">
      {groups.map((group) => {
        const isExpanded = expandedIps.has(group.ip_address);
        return (
          <li key={group.ip_address} className="anon-tree__group">
            <button
              type="button"
              className={`anon-tree__ip-row ${isExpanded ? "is-expanded" : ""}`}
              onClick={() => toggleIp(group.ip_address)}
              aria-expanded={isExpanded}
            >
              <i className={`bi ${isExpanded ? "bi-caret-down-fill" : "bi-caret-right-fill"} anon-tree__caret`} />
              <i className="bi bi-hdd-network anon-tree__ip-icon" />
              <span className="anon-tree__ip-label">{group.ip_address}</span>
              <span className="anon-tree__ip-count">{group.items.length}</span>
            </button>

            {isExpanded && (
              <ul className="anon-tree__items">
                {group.items.map((item, index) => (
                  <TestResultListItem
                    key={item.idtonalresult}
                    item={item}
                    index={group.items.length - index}
                    isActive={selectedItem?.idtonalresult === item.idtonalresult}
                    formatDate={formatDate}
                    onClick={() => onSelect(item)}
                  />
                ))}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}
